import { PayloadAction } from '@reduxjs/toolkit';

import { GalleryState } from 'editor/src/store/gallery/types';

// The split stays known after its notice is closed, as its pages keep their page numbers.
const dismissPdfSplitReducer = (state: GalleryState, action: PayloadAction<string>) => {
  state.pdfSplits?.forEach((split) => {
    if (split.uploaderId === action.payload) {
      split.dismissed = true;
    }
  });
};

export default dismissPdfSplitReducer;
